import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PlantsWithBOMByProductListApiService } from './plants-with-bom-by-product-list.api.service';
import * as PlantsWithBOMByProductListActions from './plants-with-bom-by-product-list.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class PlantsWithBOMByProductListEffects {
  loadPlantsWithBOMByProductList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlantsWithBOMByProductListActions.loadPlantsWithBOMByProductList),
      mergeMap(({ products }) =>
        this.api.getPlantsWithBOMByProductList(products).pipe(
          map((result) =>
            PlantsWithBOMByProductListActions.loadPlantsWithBOMByProductListSuccess({ products, result }),
          ),
          catchError((error) =>
            of(PlantsWithBOMByProductListActions.loadPlantsWithBOMByProductListFailure({ products, error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private api: PlantsWithBOMByProductListApiService,
  ) {}
}
